import { Component, h } from 'preact';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';

import get from '../utils/get';

export default class ThingsToKnow extends Component {
  constructor() {
    super();

    this.state = {
      posts: [],
      timestamp: null
    };

    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.update();
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  shouldComponentUpdate(_, nextState) {
    if (this.state.timestamp === nextState.timestamp) return false;

    return true;
  }

  componentDidUpdate() {
    if (this.props.onUpdate) this.props.onUpdate();
  }

  prepareDate() {
    const ts = this.state.timestamp;

    if (!ts) return '';

    const distance = distanceInWordsStrict(new Date(), new Date(ts), {
      addSuffix: true
    });

    return distance;
  }

  update() {
    get('https://apps.texastribune.org/data/85th-texas-legislature/feed.json')
      .then(JSON.parse)
      .then(data => {
        const posts = data.data.what_to_know;
        const timestamp = data.timestamp;

        this.setState({ posts, timestamp });
      })
      .catch(err => console.error(err))
      .then(() => (this.timer = setTimeout(this.update, 1000 * 60 * 5)));
  }

  render() {
    const renderedPosts = this.state.posts.map((post, idx) => {
      return (
        <li
          className="news-list__item"
          key={idx}
          dangerouslySetInnerHTML={{ __html: post.value }}
        />
      );
    });

    return (
      <div className="widget">
        <header className="widget__titlebar">
          <h2 className="widget__title">
            What to know<span class="widget__title-hide"> right now</span>
          </h2>
          <p className="widget__sub-title">
            Updated <time>{this.prepareDate()}</time>
          </p>
        </header>
        <div className="widget__content">
          <ul className="news-list">
            {renderedPosts}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/things-to-know.js